import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { GetPermission, GetPermissionAll, GetDictionary } from '../../utilities/CommonFunctions'

function UserMenu() {
  const [dic_lng, setdic_lng] = useState({});
  const navigate = useNavigate();
  function navigateURL(component) {
    window.location.href = globalThis.config.Settings.ApiConfiguration.Appurl + component;
  }
  // navigate(location.pathname.includes('/as')) ? navigateURL("Plantation/as") : navigateURL("Plantation");

  const { user: currentUser } = useSelector((state) => state.auth);
  const userloginid = currentUser.userid;
  const [Resource, setResource] = useState({});

  const items = [
    // { Resource.menu28 == 'resource-28' ? "nav-item" : "nav-item d-none" } ?
    {
      label: 'Plantation',
      icon: 'pi pi-palette',
      items: [ {
          label: 'Site Registration',
          command: () => {
            location.pathname.includes('/as') ? navigate("/Plantation/as") : navigate("/Plantation")
          }
        }, {
          label: 'Yearly Target',
          command: () => {
            location.pathname.includes('/as') ? navigate("/AddPlantationtarget/as") : navigate("/AddPlantationtarget")
          }
        }, {
          label: 'Progress',
          command: () => {
            location.pathname.includes('/as') ? navigate("/PlantationProgress/as") : navigate("/PlantationProgress")
          }
        }, {
          label: 'Inspection',
          command: () => {
            location.pathname.includes('/as') ? navigate("/PlantationInspection/as") : navigate("/PlantationInspection")
          }
        }, {
          label: 'Inspection Report Reviewing ',
          command: () => {
            location.pathname.includes('/as') ? navigate("/InspectionReview/as") : navigate("/InspectionReview")
          }
        },
        {
          label: 'Report',
          command: () => {
            location.pathname.includes('/as') ? navigate("/Report/as") : navigate("/Report")
          }
        },
      ]
    },
    {
      label: 'Admin Setting',
      icon: 'pi pi-user',
      items: [ {
          label: 'Dictionary',
          command: () => {
            location.pathname.includes('/as') ? navigate("/BilingualSettings/as") : navigate("/BilingualSettings")
          }
        }, {
          label: 'LookUp Settings',
          disabled: true,
          command: () => {
            location.pathname.includes('/as') ? navigate("/LookUpSettings/as") : navigate("/LookUpSettings")
          }
        }, {
          label: 'Role',
          command: () => {
            location.pathname.includes('/as') ? navigate("/AdminRoles/as") : navigate("/AdminRoles")
          }
        }, {
          label: 'User',
          command: () => {
            location.pathname.includes('/as') ? navigate("/User/as") : navigate("/User")
          }
        }, {
          label: 'User Role Mapping',
          command: () => {
            location.pathname.includes('/as') ? navigate("/UserRole_Mapping/as") : navigate("/UserRole_Mapping")
          }
        }, {
          label: 'Role Responsblity Matrix',
          command: () => {
            location.pathname.includes('/as') ? navigate("/UserRoleMatrix/as") : navigate("/UserRoleMatrix")
          }
        },
      ]
    },
    {
      label: 'Company Registration',
      icon: 'pi pi-link',
      items: [ {
          label: 'Company Registration',
          command: () => {
            location.pathname.includes('/as') ? navigate("/ContractorKYC_details/as") : navigate("/ContractorKYC_details")
          }
        }, {
          label: 'External User',
          command: () => {
            location.pathname.includes('/as') ? navigate("/External_user/as") : navigate("/External_user")
          }
        }
      ]
    }
  ];
  const items1 = [
    {
      label: 'Plantation',
      icon: 'pi pi-palette',
      items: [ {
          label: 'Yearly Target',
          command: () => {
            location.pathname.includes('/as') ? navigate("/AddPlantationtarget/as") : navigate("/AddPlantationtarget")
          }
        }, {
          label: 'Progress',
          command: () => {
            location.pathname.includes('/as') ? navigate("/PlantationProgress/as") : navigate("/PlantationProgress")
          }
        },
      ]
    },

    {
      label: 'Company Registration',
      icon: 'pi pi-link',
      items: [
        {
          label: 'Company Registration',
          command: () => {
            location.pathname.includes('/as') ? navigate("/ContractorKYC_details/as") : navigate("/ContractorKYC_details")
          }
        }, {
          label: 'External User',
          command: () => {
            location.pathname.includes('/as') ? navigate("/External_user/as") : navigate("/External_user")
          }
        }
      ]
    }
  ];

  // ---------------------------------------------------------------------------------
  useEffect(()=>{
    // console.log(JSON.parse(currentUser.pmis_accessmatrix))
    ApplicationManual();
  },[])
  async function ApplicationManual() {
    try {
      let res = [];
      let resourses = JSON.parse(currentUser.pmis_accessmatrix);
          // globalThis.config.Settings.ApiConfiguration.Permissions = response.data.Permissions;
          resourses.forEach(element => {
            var resource_label = globalThis.config.Settings.Locale == 'en' ? element.resource_en : element.resource_as;
            var element_url = globalThis.config.Settings.Locale == 'en' ? element.url_en : element.url_as
            if (element.menulev0 != 0 && res[element.menulev0] == undefined) {
              if (element_url != null && element_url != '' && element_url != '-') {
                res[element.menulev0] = { label: resource_label, icon: 'bi bi-speedometer', url: globalThis.config.Settings.ApiConfiguration.BaseURL+'' + element_url }
              } else {
                if(element.resource_id==140){
                  res[element.menulev0] = { label: resource_label, icon: 'bi bi-person-gear' }
                }else if(element.resource_id==167){
                  res[element.menulev0] = { label: resource_label, icon: 'bi bi-person-plus' }
                }else{
                res[element.menulev0] = { label: resource_label, icon: 'bi bi-tree' }
                }
              }
            } if (element.menulev1 != 0) {
              if (res[element.menulev0].items == undefined) {
                res[element.menulev0].items = [];
              }
              (res[element.menulev0].items)[element.menulev1] = { label: resource_label, icon: 'bi bi-chevron-right' }
              if (element.menulev2 == 0) {
                if (element_url != null && element_url != '' && element_url != '-') {
                  (res[element.menulev0].items)[element.menulev1] = { label: resource_label, icon: 'bi bi-chevron-right', url: globalThis.config.Settings.ApiConfiguration.BaseURL+'' + element_url }
                } else {
                  (res[element.menulev0].items)[element.menulev1] = { label: resource_label, icon: 'bi bi-chevron-right' }
                }

              }
            }
            if (element.menulev2 != 0) {
              if (res[element.menulev0].items[element.menulev1].items == undefined) {
                res[element.menulev0].items[element.menulev1].items = [];
              }
              (res[element.menulev0].items[element.menulev1].items).push({ label: resource_label, icon: 'bi-chevron-right' })
            }
            // res["menu" + element.resource_id] = "resource-" + element.resource_id
          });
          setResource(res);
    } catch { }
  };

  return (
    <div className="card">
      {
        Resource.length > 0 ?
          <Menubar model={Resource} />
          : ""
      }
      {/* {
        currentUser.role_id == 63 ?
          <Menubar model={items1} />
          :
          <Menubar model={items} />
      } */}

    </div>
  )
}

export default UserMenu;
